export const en = {
  // 네비게이션
  nav_home: "Home",
  nav_growth: "Growth Records",
  nav_statistics: "Statistics",
  nav_family: "Family Settings",
  nav_backup: "Backup",
  nav_add_memory: "Add Memory",
  nav_main_menu: "Main Menu",
  nav_photobook: "Create Photobook",
  nav_family_settings: "Family Settings",
  nav_share: "Share",
  nav_memories: "View Memories",
  nav_albums: "Albums",
  nav_invite: "Invite Family",
  nav_admin: "Admin",
  nav_activity_log: "Activity Log",
  nav_trash: "Trash",
  nav_profile: "Profile",
  nav_login: "Login",
  nav_logout: "Logout",
  
  // 사이트 공통
  site_title: "MinhoMinah",
  language: "Language",
  
  // 인증
  auth_login: "Login",
  auth_logout: "Logout",
  auth_signup: "Sign Up",
  auth_account: "Account",
  
  // Login Page
  login: {
    title: "Login",
    signupTitle: "Sign Up",
    subtitle: "Share precious memories of Minho & Minah",
    name: "Name",
    namePlaceholder: "John Doe",
    email: "Email",
    emailPlaceholder: "your@email.com",
    password: "Password",
    passwordPlaceholder: "••••••••",
    confirmPassword: "Confirm Password",
    passwordMismatch: "Passwords do not match.",
    passwordTooShort: "Password must be at least 6 characters.",
    signupSuccess: "Sign up successful! Please check your email.",
    emailAlreadyExists: "This email is already registered.",
    signupError: "An error occurred during sign up.",
    loginError: "Invalid email or password.",
    signingUp: "Signing up...",
    loggingIn: "Logging in...",
    haveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    loginButton: "Login",
    signupButton: "Sign Up"
  },
  
  // 히어로 섹션
  hero_title: "Minho & Minah",
  hero_subtitle: "Precious Moments",
  hero_description: "A space to record our children's growth stories, keep memories, and share love",
  
  // 통계 카드
  stat_total_posts: "Total Posts",
  stat_photos: "Photos",
  stat_videos: "Videos",
  stat_milestones: "Milestones",
  
  // 필터 섹션
  filter_title: "Filter Memories",
  filter_search_placeholder: "Search by title or description...",
  filter_age_view: "View by Age",
  filter_all: "All",
  filter_tags: "Filter Tags",
  filter_reset: "Reset",
  filter_slideshow: "Slideshow",
  filter_photobook: "Create Photo Book",
  filter_all_people: "View All",
  filter_minho: "Minho",
  filter_mina: "Minah",
  filter_both: "Minho & Minah",
  
  // 레이아웃
  layout_grid: "Grid",
  layout_masonry: "Masonry",
  layout_timeline: "Timeline",
  
  // 공통 메시지
  msg_loading: "Loading...",
  msg_no_data: "No data",
  msg_error: "An error occurred",
  msg_success: "Operation completed",
  no_memories: "No memories found.",
  
  // 버튼
  btn_save: "Save",
  btn_cancel: "Cancel",
  btn_edit: "Edit",
  btn_delete: "Delete",
  btn_share: "Share",
  btn_close: "Close",
  
  // 백업 페이지
  backup_title: "Backup & Export",
  backup_subtitle: "Keep your precious memories safe and restore them anytime",
  backup_full: "Full Backup",
  backup_full_desc: "Backup all data at once",
  backup_full_download: "Download Full Backup",
  backup_memories: "Memories Backup",
  backup_memories_desc: "Backup only photos and memory info",
  backup_memories_download: "Download Memories Backup",
  backup_settings: "Settings Backup",
  backup_settings_desc: "Backup only family settings and tags",
  backup_settings_download: "Download Settings Backup",
  backup_restore: "Restore Backup",
  backup_restore_desc: "Drag or click to select backup file",
  backup_restore_formats: "Supported formats: JSON, ZIP",
  backup_restore_btn: "Restore Backup",
  backup_auto: "Auto Backup Settings",
  backup_auto_enable: "Enable Auto Backup",
  backup_frequency: "Backup Frequency",
  backup_daily: "Daily",
  backup_weekly: "Weekly",
  backup_monthly: "Monthly",
  backup_time: "Backup Time",
  backup_max_count: "Max Backup Count",
  backup_save_settings: "Save Settings",
  backup_history: "Backup History",
  
  // 홈페이지
  hero_our_children: "Our Children",
  hero_view_memories: "Browse Memories",
  hero_add_memory: "Add Memory",
  stat_total_memories: "Total Memories",
  section_our_children: "Our Children",
  child_minho_title: "Minho",
  child_minho_desc: "Our reliable firstborn, Minho's growth story",
  child_minho_view: "View Minho's Memories",
  child_mina_title: "Minah",
  child_mina_desc: "Our lovely youngest, Minah's adorable daily life",
  child_mina_view: "View Minah's Memories",
  section_recent_memories: "Recent Memories",
  view_all_memories: "View All Memories",
  cta_title: "Record Today's Precious Moments",
  cta_desc: "Keep memories that shine through time at MinhoMinah.com",
  btn_upload_memory: "Upload Memory",
  btn_start: "Get Started",
  
  // 업로드 페이지
  upload_title: "Add New Memory",
  upload_edit_title: "Edit Memory",
  upload_subtitle: "Record precious moments forever",
  upload_edit_subtitle: "Edit your precious moments",
  upload_media_label: "Photos/Videos *",
  upload_drag_drop: "Drag files here or",
  upload_select_file: "Select Files",
  upload_file_types: "JPG, PNG, GIF, MP4, MOV (Max 50MB)",
  upload_existing_files: "Existing Files",
  upload_title_label: "Title *",
  upload_title_placeholder: "Enter memory title",
  upload_title_required: "Please enter a title",
  upload_description_label: "Description",
  upload_description_placeholder: "Enter memory description",
  upload_date_label: "Date *",
  upload_date_required: "Please select a date",
  upload_people_label: "People Together",
  upload_add_person: "Add Person",
  upload_tags_label: "Tags",
  upload_add_tag: "Add Tag",
  upload_album_label: "Albums",
  upload_submit: "Add Memory",
  upload_edit_submit: "Update Memory",
  upload_uploading: "Uploading...",
  upload_editing: "Updating...",
  upload_min_one_file: "Please add at least one photo or video.",
  upload_min_one_media: "At least one photo or video must be kept.",
  upload_login_required: "Login required.",
  upload_error: "Error occurred during upload",
  upload_edit_error: "Error occurred during update",
  
  // 추억 갤러리 페이지
  memories: {
    title: "Memory Gallery",
    error: "Error occurred while loading memories.",
    refresh: "Refresh",
    searchPlaceholder: "Search memories...",
    count: " memories",
    ageFilter: "View by Age",
    all: "All",
    age: " years",
    filter: "Filter",
    personFilter: "Person",
    yearFilter: "Year",
    year: "",
    tagFilter: "Tags",
    filterReset: "Reset Filters",
    photos: " photos",
    noResults: "No search results.",
    noMemories: "No memories yet.",
    loadingMore: "Loading more memories...",
    allLoaded: "All memories loaded",
    deleteConfirmTitle: "Delete this memory?",
    deleteConfirmMessage: "will be deleted. This cannot be undone.",
    cancel: "Cancel",
    deleting: "Deleting...",
    edit: "Edit",
    delete: "Delete",
    deleteError: "Failed to delete the memory.",
    permissionError: "You don't have permission to delete. Please contact the administrator.",
    slideshow: "Slideshow",
    share: "Share",
    download: "Download",
    comments: "Comments",
    backToGallery: "Back to Memory Gallery",
    notFound: "Memory not found.",
    notFoundDescription: "The memory you requested does not exist or has been deleted.",
    loadError: "An error occurred while loading the memory.",
    addToAlbum: "Add to Album",
    selectAlbums: "Select Albums",
    updateError: "Failed to update the memory."
  },
  
  // 성장 기록 페이지
  growth: {
    title: "Growth Records",
    subtitle: "Track Minho and Minah's growth journey with graphs",
    addRecord: "Add Record",
    currentStatus: "Current Status",
    recentGrowth: "Recent Growth",
    last3Months: "Last 3 Months",
    lastRecord: "Last Record",
    height: "Height",
    weight: "Weight",
    heightCm: "Height (cm)",
    weightKg: "Weight (kg)",
    growthChart: "Growth Chart",
    recordHistory: "Growth Record History",
    date: "Date",
    age: "Age",
    memo: "Memo",
    actions: "Actions",
    noRecords: "No growth records yet.",
    addRecordTitle: "Add Growth Record",
    person: "Person",
    selectPerson: "Select",
    memoOptional: "Memo (Optional)",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    recordAdded: "Growth record added!",
    recordDeleted: "Record deleted.",
    deleteConfirm: "Delete this record?",
    noAgeInfo: "No age info",
    years: " years",
    months: " months",
    daysAgo: " days ago"
  },
  
  // 통계 페이지
  statistics: {
    title: "Statistics Dashboard",
    totalMemories: "Total Memories",
    photos: "Photos",
    videos: "Videos",
    mostActiveMonth: "Most Active Month",
    monthlyStats: "Monthly Memory Statistics",
    personStats: "Person Statistics",
    tagCloud: "Tag Cloud",
    memoryCount: "Memory Count",
    noData: "No data yet",
    noTags: "No tags yet",
    noneYet: "None yet"
  },
  
  // 앨범 페이지
  albums: {
    title: "Albums",
    newAlbum: "New Album",
    noAlbums: "No albums yet",
    createFirst: "Create your first album!",
    memoriesCount: " memories",
    createAlbum: "Create Album",
    albumName: "Album Name",
    albumNamePlaceholder: "e.g., Family Trip 2024",
    description: "Description",
    descriptionPlaceholder: "Enter a description for this album",
    makePublic: "Make this album public",
    create: "Create",
    creating: "Creating...",
    cancel: "Cancel",
    backToAlbums: "Back to Albums",
    notFound: "Album not found",
    noMemories: "No memories in this album",
    addMemoriesDesc: "You can add memories from the memories gallery",
    addMemories: "Add Memories",
    editAlbum: "Edit Album",
    save: "Save",
    saving: "Saving...",
    deleteAlbum: "Delete Album",
    deleteConfirm: "Are you sure you want to delete this album? The memories in it will not be deleted.",
    delete: "Delete",
    deleting: "Deleting...",
    updateError: "Failed to update albums.",
    setCover: "Set as Album Cover"
  },
  
  // 포토북 만들기 페이지
  photobook: {
    title: "Create Photobook",
    subtitle: "Turn your precious memories into a beautiful photobook",
    settings: "Photobook Settings",
    template_selection: "Template Selection",
    template_classic: "Classic",
    template_classic_desc: "Elegant and traditional design",
    template_modern: "Modern",
    template_modern_desc: "Contemporary and stylish layout",
    template_minimal: "Minimal",
    template_minimal_desc: "Clean and simple style",
    period_to_include: "Period to Include",
    start_date: "Start Date",
    end_date: "End Date",
    options: "Options",
    include_cover_page: "Include Cover Page",
    include_stats_page: "Include Statistics Page",
    include_index_page: "Include Index Page",
    include_timeline: "Include Timeline",
    people_to_include: "People to Include",
    all: "All",
    minho_only: "Minho Only",
    mina_only: "Minah Only",
    minho_mina_together: "Minho & Minah Together",
    preview: "Preview",
    generate_photobook: "Generate Photobook",
    photobook_preview: "Photobook Preview",
    creating_photobook: "Creating Photobook...",
    preparing: "Preparing photos..."
  },
  
  // 활동 로그 페이지
  activityLog: {
    title: "Activity Log",
    export: "Export",
    allActivities: "All Activities",
    create: "Create",
    update: "Update",
    delete: "Delete",
    share: "Share",
    noActivities: "No activity records",
    noActivitiesDesc: "Activities will be recorded here when you add or edit memories.",
    action_create: "Added a new memory",
    action_update: "Updated a memory",
    action_delete: "Deleted a memory",
    action_restore: "Restored a memory",
    action_share: "Shared a memory",
    action_download: "Downloaded a memory"
  },
  
  // Trash Page
  trash: {
    title: "Trash",
    auto_delete_notice: "Items in trash will be permanently deleted after 30 days.",
    select_all: "Select All",
    deselect_all: "Deselect All",
    selected_count: " selected",
    restore: "Restore",
    delete_permanently: "Delete Permanently",
    empty_title: "Trash is empty",
    empty_desc: "Deleted items will appear here.",
    deleted_date: "Deleted on",
    permanent_delete_days: " days until permanent deletion",
    confirm_permanent_delete: "Are you sure you want to permanently delete the selected items? This action cannot be undone."
  },
  
  // Profile Page
  profile: {
    title: "My Profile",
    loading_error: "Error loading profile.",
    not_found: "Profile not found.",
    update_success: "Profile updated successfully.",
    update_error: "Error updating profile.",
    basic_info: "Basic Information",
    email: "Email",
    username: "Username",
    username_placeholder: "Enter username",
    full_name: "Full Name",
    full_name_placeholder: "Enter full name",
    not_set: "Not set",
    role: "Role",
    role_parent: "Parent",
    role_family: "Family",
    role_viewer: "Viewer",
    role_parent_desc: "Full access to all features.",
    role_family_desc: "Can view memories and add comments.",
    role_viewer_desc: "Can only view memories.",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    account_info: "Account Information",
    joined_date: "Joined",
    last_updated: "Last Updated"
  },

  // Admin Page
  admin: {
    title: "Admin Page",
    subtitle: "Manage users and monitor system activities.",
    accessDenied: "Access Denied",
    accessDeniedDesc: "This page is only accessible to administrators (parent).",
    userManagement: "User Management",
    activityLog: "Activity Log",
    loading: "Loading...",
    user: "User",
    email: "Email",
    role: "Role",
    joinedDate: "Joined",
    actions: "Actions",
    edit: "Edit",
    roleBadge: {
      parent: "Admin",
      family: "Family",
      viewer: "Viewer"
    },
    updateRole: "Change Role",
    updating: "Updating...",
    roleUpdated: "User role has been updated.",
    roleUpdateFailed: "Failed to update role",
    profileModal: {
      title: "Edit Profile",
      email: "Email",
      username: "Username",
      fullName: "Full Name",
      save: "Save",
      cancel: "Cancel",
      saving: "Saving...",
      updated: "Profile has been updated.",
      updateFailed: "Failed to update profile"
    },
    activity: {
      action: "Action",
      created: "Created",
      updated: "Updated",
      deleted: "Deleted",
      details: "Details",
      date: "Date",
      noData: "No activity logs available."
    },
    unknown: "Unknown",
    notSet: "Not Set",
    ago: "ago",
    tagManagement: "Tag Management",
    peopleManagement: "People Management",
    tags: {
      name: "Tag Name",
      usageCount: "Usage Count",
      memories: " memories",
      deleted: "Tag has been deleted.",
      deleteFailed: "Failed to delete tag.",
      deleteConfirm: "Are you sure you want to delete this tag?",
      deleteConfirmWithUsage: "This tag is used in {{count}} memories. Are you sure you want to delete it?"
    },
    people: {
      name: "Name",
      usageCount: "Usage Count",
      memories: " memories",
      birthdate: "Birth Date",
      deleted: "Person has been deleted.",
      deleteFailed: "Failed to delete person.",
      deleteConfirm: "Are you sure you want to delete this person?",
      deleteConfirmWithUsage: "This person is tagged in {{count}} memories. Are you sure you want to delete?"
    }
  }
} as const;